// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".P63yIMBjWK80P-YASy8F5Q\\=\\= .layout{margin:40px 0}", "",{"version":3,"sources":["/app/client_react/src/components/Shared/CelebrationState/CelebrationState.styl"],"names":[],"mappings":"AACI,oCACI,aAAQ","file":"CelebrationState.styl","sourcesContent":[":local(.global) {\n    .layout {\n        margin: 40px 0;\n    }\n}"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "P63yIMBjWK80P-YASy8F5Q=="
};
module.exports = ___CSS_LOADER_EXPORT___;
